import React from 'react';
import SamplingBox from './SamplingBox';
import SignalsBox from './SignalsBox';
import StimuliBox from './StimuliBox';
import EventsBox from './EventsBox';

const VideoParameters = props => {
  return [
    <SamplingBox key="sampling" />,
    <SignalsBox key="signals" />,
    <StimuliBox key="stimuli" />,
    <EventsBox key="events" />
  ];
};

export default VideoParameters;



// WEBPACK FOOTER //
// ./src/scenes/analysis/components/analysis/parameters/VideoParameters.js